export enum CookieKeyType {
  LANG = "LANG",
  ACCESS_TOKEN = "AccessToken",
  RESEND_AUTH_MAIL = "ResendAuthMail",
  POLICY = "Policy",
  REDIRECT_URL = "RedirectUrl",
  DO_NOT_SHOW_SAMPLE_POPUP = "DoNotShowSamplePopup",
  OPEN_CREDIT_BANNER = "OpenCreditBanner",
  AUTH_ORG_EMAIL_SIGNUP_CONTEXT = 'AUTH_ORG_EMAIL_SIGNUP_CONTEXT'
}